import { useGetAllOfficesQuery } from '@/app/features/control-panel/organization/organization.api';
import type { EncashmentBatchItem } from '@/app/features/employee/emp-payroll';
import { Calendar03Icon } from '@/icons';
import { formatDate } from '@/utils';
import type { ChangeEvent } from 'react';
import FilterSelect from '../shared/FilterSelect';
import SearchInput from '../shared/SearchInput';

type Props = {
  /** The batch on screen; its fiscal year is shown, not chosen. */
  batch?: EncashmentBatchItem;
  searchPlaceholder: string;
  onSearch: (event: ChangeEvent<HTMLInputElement>) => void;
  officeId?: string;
  onOfficeChange: (officeId?: string) => void;
};

/** Search, the batch's fiscal year and an office filter, for both record pages. */
const EncashmentToolbar = ({
  batch,
  searchPlaceholder,
  onSearch,
  officeId,
  onOfficeChange,
}: Props) => {
  const { data: officeData } = useGetAllOfficesQuery({
    params: { take: 0, skip: 0 },
  });

  return (
    <>
      <SearchInput
        placeholder={searchPlaceholder}
        onChange={onSearch}
        className="w-[250px]"
      />

      {batch && (
        <div className="inline-flex items-center gap-2 h-10 px-3 rounded-lg border border-theme-gray-700 text-white/80 text-sm whitespace-nowrap">
          <Calendar03Icon size={16} className="text-white/60" />
          {formatDate(batch.fiscal_year_start, 'DD MMM, YYYY')} –{' '}
          {formatDate(batch.fiscal_year_end, 'DD MMM, YYYY')}
        </div>
      )}

      <FilterSelect
        width={170}
        placeholder="Offices"
        value={officeId}
        onChange={onOfficeChange}
        options={officeData?.data?.data?.map((office: any) => ({
          value: office.id,
          label: office.name,
        }))}
      />
    </>
  );
};

export default EncashmentToolbar;
